// extracted by mini-css-extract-plugin
export default {"switcher":"fhrkk","switcherButton":"VCQKp"};